import React, { Component } from 'react';

export default class OHSFormLink extends Component {
    render() {return(
        <a href={`/ohs_forms/${this.props.form.toLowerCase()}.pdf`} target='_blank' rel='noreferrer'>{this.props.title}</a>
    );}
}